import React from "react";
import { Field, reduxForm } from "redux-form";
import { Button, Input } from "expano-components";
import { Main, Dashboard } from "components";
import { createProperty } from "actions/properties";
import { ReactComponent as PropertyIcon } from "icons/property.svg";

const InputField = (props) => <Input {...props} />;

const PropertyNew = ({ handleSubmit, pristine, history }) => {
  const onSubmit = async (values) => {
    const id = await createProperty(values);
    history.push(`/properties/${id}`);
  };

  return (
    <Main
      page={{
        name: "Właściwości",
        icon: <PropertyIcon />,
        breadcrumbs: [
          {
            name: "Właściwości",
            path: "/properties",
          },
          { name: "Dodaj właściwość" },
        ],
      }}
    >
      <Dashboard
        footer={
          <>
            <Button type="cancel" onClick={() => history.push("/properties")} />
            <Button
              type="save"
              disabled={pristine}
              text="Utwórz"
              onClick={handleSubmit(onSubmit)}
            />
          </>
        }
      >
        <form
          className="dashboard__form"
          onSubmit={handleSubmit(onSubmit)}
          noValidate
        >
          <Field
            name="external_name_pl"
            label="Nazwa zewnętrzna - pl"
            component={InputField}
            type="text"
          />
        </form>
      </Dashboard>
    </Main>
  );
};

export default reduxForm({
  form: "create-property",
  enableReinitialize: true,
})(PropertyNew);
